import { Location } from '@angular/common';
import { AfterContentInit, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { Temporal } from '@js-temporal/polyfill';
import * as _ from 'lodash';
import { db } from 'src/app/db/db';

import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { EConsommableDialyse } from 'src/app/domain/Dialyse/enum/consommable-dialyse';
import { ELocalisationDialyse } from 'src/app/domain/Dialyse/enum/localisation-dialyse';
import { EModeDesinfection } from 'src/app/domain/Dialyse/enum/mode-desinfection';
import { Generateur } from 'src/app/domain/Dialyse/generateur';
import { Consommable } from 'src/app/domain/consommable';
import { EFlaskType } from 'src/app/domain/enums/flask-type';
import { EServiceType } from 'src/app/domain/enums/service-type';
import { Flacon } from 'src/app/domain/flacon';
import { Prelevement } from 'src/app/domain/prelevement';
import { ECallerOfScan } from 'src/app/models/caller-of-scan';
import { ENavigationRoute } from 'src/app/models/enums/navigation-route';
import { CoreData } from 'src/app/tools/core-data/core-data';
import { StringTool } from 'src/app/tools/mapping/string.tool';
import { ConfirmBoxDialog } from 'src/app/tools/ui/confirm-box/confirm-box.component';
import { ConsommableBoxDialog } from 'src/app/tools/ui/consommable-box/consommable-box';
import { StringConverter } from 'src/app/tools/ui/string-converter';
import { PreventDoubleClickDirective } from '../../tools/directive/prevent-double-click.directive';
import { ETaskStatus } from 'src/app/models/enums/task-status';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { NotificationManager } from 'src/app/tools/ui/notification-manager';
import { FlaconRepository } from 'src/app/db/repository/flacon.repository';
import { ConsommableRepository } from 'src/app/db/repository/consommable.repository';
import { GenerateurRepository } from 'src/app/db/repository/generateur.repository';
import { PrelevementRepository } from 'src/app/db/repository/prelevement.repository';
import { Intervention } from 'src/app/domain/intervention';
import { InterventionRepository } from 'src/app/db/repository/intervention.repository';
import { EInterventionStatus } from 'src/app/domain/enums/intervention-status';

@Component({
    selector: 'app-dialyse',
    templateUrl: './dialyse.component.html',
    styleUrl: './dialyse.component.scss',
    standalone: true,
    imports: [MatFormFieldModule, MatInputModule, NgxMaterialTimepickerModule, MatButtonModule, MatIconModule, FormsModule, MatSelectModule, MatOptionModule, PreventDoubleClickDirective, MatSlideToggleModule]
})
export class DialyseComponent implements OnInit, AfterContentInit {
    EInterventionStatus = EInterventionStatus;
    ELocalisationDialyse = ELocalisationDialyse;
    EServiceType = EServiceType;
    EFlaskType = EFlaskType;
    public LocalisationDialyseList: string[] = Object.values(ELocalisationDialyse)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getLocalisationDialyseLabel(x));

    public ConsommableList: string[] = Object.values(EConsommableDialyse)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getConsommableDialyseLabel(x));

    public ModeDesinfectionList: string[] = Object.values(EModeDesinfection)
        .filter(x => !isNaN(Number(x)))
        .map((x: any) => StringConverter.getModeDesinfectionLabel(x));

    private appareilCode: string = '';
    private scannedCode: string = '';
    private propertyCode: string = '';
    Generateur?: Generateur;

    DefaultTime!: string;
    TimeSampling!: string
    _SamplingDate!: Date

    FullForm: boolean = false;
    Intervention: Intervention | undefined;

    constructor(
        private location: Location,
        private router: Router,
        private coreData: CoreData,
        private snackBar: MatSnackBar,
        private dialog: MatDialog,
        private route: ActivatedRoute,
        private prelevementRepository: PrelevementRepository,
        private generateurRepository: GenerateurRepository,
        private consommableRepository: ConsommableRepository,
        private flaconRepository: FlaconRepository,
        private interventionRepository: InterventionRepository) {

    }

    ngOnInit(): void {

        this.DefaultTime = `${Temporal.Now.plainDateTimeISO().hour}:${Temporal.Now.plainDateTimeISO().minute}`
    }

    async ngAfterContentInit(): Promise<void> {

        this.appareilCode = this.route.snapshot.params['appCode'];
        this.scannedCode = this.route.snapshot.params['result'];
        this.propertyCode = this.route.snapshot.params['propertyCode'];

        this.Intervention = await this.interventionRepository.getInterventionByAppareilCode(this.appareilCode)

        this.Generateur = await this.generateurRepository.getGenerateurByCodeWithChildren(this.appareilCode);
        this.coreData.CurrentPageName = this.Generateur.ZoneSalle;
        if (this.Generateur.SamplingDate) {
            this.TimeSampling = `${this.Generateur.SamplingDate.hour}:${this.Generateur.SamplingDate.minute}`;
        }

        if (this.scannedCode) {
            this.Generateur.PrelevementGenerateurDialyseList.forEach(x => {
                let flalfla = x.Prelevement.FlaconList.find(y => y.Code === this.propertyCode)
                if (flalfla) {
                    flalfla.Barcode = this.scannedCode;
                    this.save(true)
                }
            })
        }
    }

    getFlaskTypeLabel(type: EFlaskType) {
        return StringConverter.getFlaskTypeLabel(type);
    }

    getConsommableDialyseLabel(type: EConsommableDialyse) {
        return StringConverter.getConsommableDialyseLabel(type);
    }

    getUniquePSV() {
        if (!this.Generateur)
            return;

        return _.uniqBy([
            ...this.Generateur.PrelevementGenerateurDialyseList.map(x => x.Prelevement.SamplingPoint)
        ], x => x.Name);
    }

    canBeDisabled(flacon: Flacon) {
        return flacon.Barcode !== null && flacon.Barcode !== '' && flacon.Barcode.length >= 13
            && !this.Generateur?.PrelevementGenerateurDialyseList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().find(y => y.Code !== flacon.Code && y.Barcode === flacon.Barcode);
    }

    checkBarCode(event: KeyboardEvent, barCode: string) {
        if (!barCode)
            return;
        if (barCode.length >= 14) {
            event.preventDefault()
        }
    }

    public focusNext(barcode: string, j: number, i: number, type: EServiceType, size: number) {
        if (barcode.length < 13) {
            return
        }

        let nextElementSiblingId;
        if (i < size - 1)
            nextElementSiblingId = `barcode${type}-${j}-${i + 1}`;
        else
            nextElementSiblingId = `barcode${type}-${j + 1}-${i}`;

        (document.querySelector(`#${nextElementSiblingId}`)! as any).focus()
    }

    async checkBarCodeExistence(code: string) {

        let flacon = this.Generateur?.PrelevementGenerateurDialyseList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().find(y => y.Code === code)
        if (flacon && StringTool.isNotNullOrEmpty(flacon.Barcode)
            && (this.Generateur?.PrelevementGenerateurDialyseList.map(x => x.Prelevement.FlaconList.map(y => y)).flat().find(y => y.Code !== flacon.Code && y.Barcode === flacon.Barcode)
                || await this.flaconRepository.checkIfBarcodeExists(flacon.Barcode))) {
            NotificationManager.handleError('Barcode déjà scanné !', this.snackBar)
            flacon.Barcode = ''
        }
    }

    async deleteConsommable(cons: Consommable, prel: Prelevement) {

        let sameTypeOfServiceIntervenList = await this.interventionRepository.getInterventionListWithGenerateurOnly();
        let prelevementList;

        this.Generateur!.PrelevementGenerateurDialyseList.forEach(x => _.remove(x.Prelevement.ConsommableList, y => y.NumeroLot === cons.NumeroLot))
        prelevementList = sameTypeOfServiceIntervenList.map(x => x.GenerateurDialyseList.map(y => y.PrelevementGenerateurDialyseList.map(z => z.Prelevement))).flat(2)

        prelevementList?.forEach(async x => {
            x.ConsommableList.forEach(async y => {
                await this.consommableRepository.deleteConsommableByNumeroLot((await this.prelevementRepository.getPrelevementEntityByCode(prel.Code))!)
            })
        })
    }

    clearSampling() {
        this.TimeSampling = '';
        this.Generateur!.SamplingDate = undefined;
    }

    timeSetSampling(event: string) {
        if (!this.Generateur)
            return;
        const time = event.split(':');
        this.Generateur.SamplingDate = Temporal.Now.plainDateTimeISO();
        this._SamplingDate = new Date();
        this._SamplingDate.setHours(Number(time[0]), Number(time[1]));
        this.Generateur.SamplingDate = Temporal.PlainDateTime.from({ year: this._SamplingDate.getFullYear(), day: this._SamplingDate.getDate(), month: this._SamplingDate.getMonth() + 1, hour: this._SamplingDate.getHours(), minute: this._SamplingDate.getMinutes() });
        this.setTimeDepartDomicile();
    }

    setTimeDepartDomicile() {
        this.TimeSampling = `${this._SamplingDate.getHours()}:${this._SamplingDate.getMinutes()}`;
    }

    openBarcodeScanning(code: string) {
        this.save(true);
        // this.coreData.ScannedId = `${cassetteId}`;
        this.router.navigate([ENavigationRoute.Scan, { pageCode: this.appareilCode, propertyCode: code, callerPageType: ECallerOfScan.Appareil }]);
    }

    openConsommableBox(typeOfService: EServiceType, prel: Prelevement, cons?: Consommable) {
        const dialogRef = this.dialog.open(ConsommableBoxDialog, {
            data: {
                typeOfService,
                consommable: cons
            },
            width: '777px',
            disableClose: true
        });

        dialogRef.afterClosed().subscribe(async (result: Consommable) => {
            if (result) {
                await db.updateLastUsedConsommableByType(result, typeOfService)
                result.Id = await this.consommableRepository.attachConsommable(result, (await this.prelevementRepository.getPrelevementEntityByCode(prel.Code))!);
                prel.ConsommableList.push(result)
                // switch (typeOfService) {
                //     case EServiceType.Dialyse:
                //         this.Generateur!.PrelevementGenerateurDialyseList.forEach(x => x.Prelevement.ConsommableList.push(result))
                //         break;
                // }
                NotificationManager.handleSuccess('Consommable ajouté', this.snackBar);
            }
        });
    }

    checkIfThereAreAtLeastOneConsommableWhereThereIsABarCode() {
        for (let i = 0, pa = this.Generateur!.PrelevementGenerateurDialyseList[i]; i < this.Generateur!.PrelevementGenerateurDialyseList.length!; i++) {

            for (let j = 0, flafla = pa.Prelevement.FlaconList[j]; j < pa.Prelevement.FlaconList.length; j++) {

                if (flafla.Barcode && pa.Prelevement.ConsommableList.length === 0)

                    return false;
            }
        }

        return true;
    }

    canSave() {
        // let missingBarCodes = [
        //     ...this.Generateur?.PrelevementGenerateurDialyseList.filter(x => x.Prelevement.FlaconList.every(y => !StringTool.isNotNullOrEmpty(y.Barcode))).map(z => z.Prelevement.OgiCode)!
        // ]
        let alreadyScannedBarCodes = [
            ...this.Generateur?.PrelevementGenerateurDialyseList.filter(x => x.Prelevement.FlaconList.some(y => StringTool.isNotNullOrEmpty(y.Barcode)))!,
            
        ]
        let missingSamplingDate = this.Generateur?.SamplingDate ? false : true

        if ( alreadyScannedBarCodes.length === 0 || (alreadyScannedBarCodes.length > 0 && !missingSamplingDate))
            return true;

        if (alreadyScannedBarCodes.length > 0 && missingSamplingDate) {
            NotificationManager.handleWarning('Heure de prélèvement obligatoire', this.snackBar)
        }
        return false;
    }

    async showAlert(withFinishedFlag: boolean) {

        let missingBarCodes = [
            ...this.Generateur?.PrelevementGenerateurDialyseList.filter(x => x.Prelevement.FlaconList.every(y => !StringTool.isNotNullOrEmpty(y.Barcode))).map(z => z.Prelevement.OgiCode)!
        ]
        // let missingSamplingDate = this.Generateur?.SamplingDate ? false : true
        if (missingBarCodes.length === 0) {
            await this.save(withFinishedFlag)
            return;
        }
        const dialogRef = this.dialog.open(ConfirmBoxDialog, {
            data: {
                message: `Enregistrer avec ces informations manquantes ?
                        ${missingBarCodes.length > 0 ? `Code à barres:\n ${missingBarCodes.join('\n')}` : ''}`,
                withCancelButton: true
            },
            height: '80%',
        });
        dialogRef.afterClosed().subscribe(async (result: boolean) => {
            if (result) {
                await this.save(withFinishedFlag)
                return;
            }
        })
    }

    async save(withFinishedFlag: boolean, quiet?: boolean) {
        if (!this.canSave())
            return;
        // if (!this.checkIfThereAreAtLeastOneConsommableWhereThereIsABarCode()) {
        //     NotificationManager.handleSuccess('Vous devez remplir au moins 1 consommable par prélèvement', this.snackBar);
        //     return;
        // }
        if (withFinishedFlag)
            this.Generateur!.TaskStatus = ETaskStatus.Done;

        const success = await this.generateurRepository.updateGenerateur(this.Generateur!);

        if (success && !quiet) {
            NotificationManager.handleSuccess('Données enregistrées', this.snackBar);
            this.location.back()
        } else if (!success) {
            NotificationManager.handleError('Wasted Bro!', this.snackBar);
        }
    }
}
